








import { Button } from 'element-ui'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    [Button.name]: Button,
  },
})
export default class GoBackButton extends Vue {}
